/**
 * Dialog: confirmar pago de UNA nómina completa (todas las facturas).
 * Extraído de CxPPanel.jsx en Iter 236.m.14 (Carlos).
 */
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';
import { Check } from 'lucide-react';

const fmt = (n) => `$${Math.round(n || 0).toLocaleString('es-CL')}`;

export function ConfirmarPagoNominaDialog({ open, nomina, busy, onClose, onConfirm }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <AlertDialogContent data-testid="dialog-confirmar-pago-nomina" className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Check className="w-5 h-5 text-emerald-600" />
            ¿Pagar nómina completa?
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-sm">
              {nomina && (
                <div className="bg-slate-50 dark:bg-slate-900/40 border rounded p-2.5 space-y-1">
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Nómina:</span>
                    <span className="font-semibold">{nomina.nombre}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Facturas:</span>
                    <span className="font-medium">{nomina.num_facturas}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Total:</span>
                    <span className="font-bold tabular-nums text-emerald-700">
                      {fmt(nomina.total)}
                    </span>
                  </div>
                </div>
              )}
              <ul className="list-disc pl-5 text-[13px] text-muted-foreground space-y-0.5">
                <li>
                  Se marcarán <strong>todas las facturas pendientes</strong> como pagadas en el ERP.
                </li>
                <li>
                  Por cada factura con <code>alegra_id</code> se registrará un{' '}
                  <strong>payment-out</strong> en <strong>Alegra</strong> (Banco de Chile 1).
                </li>
                <li>
                  Si Alegra rechaza algún pago, esas facturas aparecerán en el banner ámbar con
                  botón "Reintentar todo".
                </li>
                <li>
                  Las facturas <strong>no volverán a aparecer</strong> en CxP después del próximo
                  sync.
                </li>
              </ul>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} data-testid="btn-cancel-pago-nomina">
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={busy}
            className="bg-emerald-600 hover:bg-emerald-700"
            data-testid="btn-confirmar-pago-nomina"
          >
            {busy ? 'Procesando…' : 'Sí, pagar todas'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
